export const autoconsumos = [
    { id: "00", name: "Sin Autoconsumo" },
    { id: "01", name: "Autoconsumo Tipo 1" },
    {
        id: "2A",
        name: "Autoconsumo tipo 2 (según el Art. 13. 2. a) RD 900/2015)",
    },
    {
        id: "2B",
        name: "Autoconsumo tipo 2 (según el Art. 13. 2. b) RD 900/2015)",
    },
    {
        id: "2G",
        name: "Servicios auxiliares de generación ligada a un autoconsumo tipo 2",
    },
    { id: "31", name: "Sin Excedentes Individual – Consumo" },
    { id: "32", name: "Sin Excedentes Colectivo – Consumo" },
    {
        id: "33",
        name: "Sin Excedentes Colectivo con acuerdo de compensación – Consumo",
    },
    { id: "41", name: "Con excedentes y compensación Individual – Consumo" },
    { id: "42", name: "Con excedentes y compensación Colectivo – Consumo" },
    {
        id: "43",
        name: "Con excedentes y compensación Colectivo a través de red – Consumo",
    },
    {
        id: "51",
        name: "Con excedentes sin compensación Individual sin cto de SSAA en Red Interior – Consumo",
    },
    {
        id: "52",
        name: "Con excedentes sin compensación Colectivo sin cto de SSAA en Red Interior – Consumo",
    },
    {
        id: "53",
        name: "Con excedentes sin compensación Individual con cto SSAA en Red Interior – Consumo",
    },
    {
        id: "54",
        name: "Con excedentes sin compensación individual con cto SSAA en Red Interior – SSAA",
    },
    {
        id: "55",
        name: "Con excedentes sin compensación Colectivo/en Red Interior – Consumo",
    },
    {
        id: "56",
        name: "Con excedentes sin compensación Colectivo/en Red Interior – SSAA",
    },
    {
        id: "57",
        name: "Con excedentes sin compensación Colectivo sin cto de SSAA (despreciable) en red interior – Consumo",
    },
    {
        id: "58",
        name: "Con excedentes sin compensación Colectivo sin cto de SSAA a través de red – Consumo",
    },
    {
        id: "61",
        name: "Con excedentes sin compensación Individual con cto SSAA a través de red – Consumo",
    },
    {
        id: "62",
        name: "Con excedentes sin compensación individual con cto SSAA a través de red – SSAA",
    },
    {
        id: "63",
        name: "Con excedentes sin compensación Colectivo a través de red – Consumo",
    },
    {
        id: "64",
        name: "Con excedentes sin compensación Colectivo a través de red – SSAA",
    },
    {
        id: "71",
        name: "Con excedentes sin compensación Individual con cto SSAA a través de red y red interior – Consumo",
    },
    {
        id: "72",
        name: "Con excedentes sin compensación individual con cto SSAA a través de red y red interior – SSAA",
    },
    {
        id: "73",
        name: "Con excedentes sin compensación Colectivo con cto de SSAA  a través de red y red interior – Consumo",
    },
    {
        id: "74",
        name: "Con excedentes sin compensación Colectivo con cto de SSAA a través de red y red interior – SSAA",
    },
];